<template>
    <!-- Navigation -->
    <div class="nav-container">
        <nav class="nav-card">
            <ul class="nav-list">
                <li
                    v-for="item in navItems"
                    :key="item.label"
                    class="nav-item"
                    @click="item.action"
                >
                    <div class="nav-left">
                        <!-- Use SVG for deposit & withdraw -->
                        <div
                            v-if="item.key === 'deposit'"
                            class="nav-icon"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="url(#grad)"
                            >
                                <defs>
                                    <linearGradient
                                        id="grad"
                                        x1="0"
                                        y1="0"
                                        x2="0"
                                        y2="24"
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop
                                            offset="0%"
                                            stop-color="#FFD84D"
                                        />
                                        <stop
                                            offset="100%"
                                            stop-color="#FF9900"
                                        />
                                    </linearGradient>
                                </defs>
                                <path
                                    d="M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3H3V7z"
                                    stroke="#FFC107"
                                    stroke-width="1.5"
                                    fill="none"
                                />
                                <rect
                                    x="3"
                                    y="10"
                                    width="18"
                                    height="11"
                                    rx="2"
                                    stroke="#FFC107"
                                    stroke-width="1.5"
                                    fill="none"
                                />
                                <path
                                    d="M12 14v4m0 0 2-2m-2 2-2-2"
                                    stroke="url(#grad)"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>

                        <div
                            v-else-if="item.key === 'withdraw'"
                            class="nav-icon"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="url(#grad)"
                            >
                                <defs>
                                    <linearGradient
                                        id="grad"
                                        x1="0"
                                        y1="0"
                                        x2="0"
                                        y2="24"
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop
                                            offset="0%"
                                            stop-color="#FFD84D"
                                        />
                                        <stop
                                            offset="100%"
                                            stop-color="#FF9900"
                                        />
                                    </linearGradient>
                                </defs>
                                <path
                                    d="M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3H3V7z"
                                    stroke="#FFC107"
                                    stroke-width="1.5"
                                    fill="none"
                                />
                                <rect
                                    x="3"
                                    y="10"
                                    width="18"
                                    height="11"
                                    rx="2"
                                    stroke="#FFC107"
                                    stroke-width="1.5"
                                    fill="none"
                                />
                                <path
                                    d="M12 18v-4m0 0-2 2m2-2 2 2"
                                    stroke="url(#grad)"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>
                        <img
                            v-else-if="item.icon"
                            :src="item.icon"
                            alt=""
                            class="nav-icon"
                        />
                        <span>{{ $t(item.label) }}</span>
                    </div>
                    <i class="fas fa-chevron-right text-white"></i>
                </li>
            </ul>
        </nav>

        <ul class="logout-card">
            <li
                class="nav-item"
                @click="openLogoutModal = true"
            >
                <div class="nav-left">
                    <img
                        src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/ak47-logout.png"
                        alt=""
                        class="nav-icon"
                    />
                    <span>{{ $t("setting.logout") }}</span>
                </div>
                <i class="fas fa-chevron-right text-white"></i>
            </li>
        </ul>

        <EditUserPasswordModal
            :visible="openEditPasswordModal"
            @close="openEditPasswordModal = false"
        />

        <ChangeLanguageModal
            :visible="openChangeLanguageModal"
            @close="openChangeLanguageModal = false"
        />

        <LogoutModal
            :visible="openLogoutModal"
            @close="openLogoutModal = false"
            @confirm="logout"
        />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { Toast } from 'vant';
import EditUserPasswordModal from './EditUserPasswordModal.vue';
import ChangeLanguageModal from './ChangeLanguageModal.vue';
import LogoutModal from './LogoutModal.vue';

export default {
    components: {
        EditUserPasswordModal,
        ChangeLanguageModal,
        LogoutModal
    },
    data() {
        return {
            openChangeLanguageModal: false,
            openEditPasswordModal: false,
            openLogoutModal: false,
            navItems: [
                {
                    label: "setting.transaction",
                    icon: "https://www.burma368.net/static/image/account/myWallet.png",
                    action: () => this.$router.push("/history"),
                },
                {
                    label: "setting.deposit",
                    key: 'deposit',
                    icon: "https://www.burma368.net/static/image/account/deposit.png",
                    action: () => this.$router.push("/deposit"),
                },
                {
                    label: "setting.withdraw",
                    key: 'withdraw',
                    icon: "https://www.burma368.net/static/image/account/withdraw.png",
                    action: () => this.$router.push("/withdraw"),
                },
                {
                    label: "footer.promotion",
                    icon: "https://www.burma368.net/static/image/account/mypromotion.png",
                    action: () => this.$router.push("/promotion"),
                },
                {
                    label: "setting.claimed_promotions",
                    // icon: "https://www.burma368.net/static/image/home/new-icon.png",
                    icon: "https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/promotion-ak47-new.png",
                    action: () => this.$router.push('/user/promotions'),
                },
                {
                    label: "setting.bank_account",
                    icon: "https://www.burma368.net/static/image/account/mybankcard.png",
                    action: () => this.$router.push("/banking"),
                },
                {
                    label: "setting.update_password",
                    icon: "https://www.burma368.net/static/image/account/resetpassword.png",
                    action: () => (this.openEditPasswordModal = true),
                },
                {
                    label: "setting.update_language",
                    icon: "https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/ak47-language.png",
                    action: () => (this.openChangeLanguageModal = true),
                },
            ],
        }
    },
    methods: {
        ...mapActions(["logoutUser", "fetchUser"]),

        async logout() {
            await this.logoutUser();
            if (this.$route.path === "/home") {
                // this.$router.go();
            } else {
                this.$router.push("/home");
            }
            Toast.success(
                this.$store.state.language === "en" ? "Logged out!" : "ထွက်ပြီးပြီ"
            );
            this.openLogoutModal = false;
        },
    }
}
</script>

<style scoped>
/* ===== Navigation ===== */
.nav-container {
    padding: 16px;
}

.nav-card,
.logout-card {
    background: #2b1c59;
    border-radius: 14px;
    overflow: hidden;
    margin-bottom: 22px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
}

.nav-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.nav-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 13px 16px;
    border-bottom: 1px solid rgba(159, 160, 191, 0.2);
    transition: background 0.15s ease;
    cursor: pointer;
}

.nav-item:last-child {
    border-bottom: none;
}

.nav-item:hover {
    background: rgba(255, 255, 255, 0.05);
}

.nav-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.nav-icon {
    width: 26px;
    height: 26px;
    object-fit: contain;
}

.nav-item span {
    font-size: 1rem;
    color: rgba(255, 255, 255, 0.8);
}

.fa-chevron-right {
    font-size: 0.8rem;
    opacity: 0.6;
}

@media (max-width: 480px) {
    .nav-item {
        padding: 12px 14px;
    }
}
</style>